import React from 'react';
import { motion } from 'framer-motion';
const reviews = [{
  initials: 'SC',
  quote: 'El banco de 30 ideas me cambió la rutina. Pasé de publicar 2 veces por semana a publicar todos los días sin estrés.',
  author: 'Sofía C., La Plata',
  niche: 'Cosméticos'
}, {
  initials: 'PA',
  quote: 'Delegué la edición y recuperé 30 horas por mes. Las usé para conseguir 2 nuevos proveedores y subir el ticket un 40%.',
  author: 'Pablo A., Neuquén',
  niche: 'Productos naturales'
}, {
  initials: 'VL',
  quote: 'Apliqué el sistema de cierre al pie de la letra. La clienta compró y me mandó a su hermana al día siguiente.',
  author: 'Valentina L., Rosario',
  niche: 'Bijoutería'
}, {
  initials: 'DM',
  quote: 'Los 500 hooks transformaron mis primeros segundos de video. Mis seguidores dicen que ahora los engancho desde el inicio.',
  author: 'Diego M., Córdoba',
  niche: 'Indumentaria deportiva'
}];
export function Testimonials() {
  return <section className="w-full py-14 px-4 bg-base relative" data-id="element-236">
      <div className="absolute inset-0 bg-primary/5 pointer-events-none" data-id="element-237" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-238">
        <div className="text-center mb-16" data-id="element-239">
          <h2 className="text-3xl md:text-4xl font-extrabold text-text-main flex items-center justify-center gap-3" data-id="element-240">
            ❤️ LO QUE DICEN LOS QUE YA LO TIENEN
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-241">
          {reviews.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-alt border border-detail/20 rounded-2xl p-8 flex flex-col" data-id="element-242">
              <div className="flex items-center gap-4 mb-6" data-id="element-243">
                <div className="w-14 h-14 rounded-full bg-primary/20 flex items-center justify-center text-primary font-bold text-xl border border-primary/30" data-id="element-244">
                  {t.initials}
                </div>
                <div data-id="element-245">
                  <div className="flex text-primary text-sm mb-1" data-id="element-246">
                    ⭐⭐⭐⭐⭐
                  </div>
                  <p className="font-bold text-text-main" data-id="element-247">{t.author}</p>
                  <p className="text-xs text-text-muted" data-id="element-248">{t.niche}</p>
                </div>
              </div>
              <p className="text-text-main text-lg italic leading-relaxed" data-id="element-249">
                "{t.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}